import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://infornotravel.com"; // canonical production domain (apex — never www)

// Lightweight per-page SEO: title, description, canonical, OG, optional noindex + JSON-LD.
// Canonical defaults to the clean current URL on the apex domain when not provided.
export function useSeo({ title, description, noindex = false, image, canonical, jsonLd }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = title;
    const set = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) { el = document.createElement("meta"); document.head.appendChild(el); }
      const [a, v] = attr;
      el.setAttribute(a, v);
      el.setAttribute("content", val);
      return el;
    };
    if (description) {
      set('meta[name="description"]', ["name", "description"], description);
      set('meta[property="og:description"]', ["property", "og:description"], description);
    }
    if (title) set('meta[property="og:title"]', ["property", "og:title"], title);
    set('meta[property="og:type"]', ["property", "og:type"], "website");
    if (image) {
      set('meta[property="og:image"]', ["property", "og:image"], image);
      set('meta[name="twitter:image"]', ["name", "twitter:image"], image);
    }
    const url = canonical || `${SITE}${pathname === "/" ? "/" : pathname.replace(/\/+$/, "")}`;
    if (!noindex) {
      set('meta[property="og:url"]', ["property", "og:url"], url);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
      link.setAttribute("href", url);
    }
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");
    // Page-scoped structured data (e.g. FAQPage) — replaced on each render.
    document.head.querySelectorAll("script[data-seo-jsonld]").forEach((el) => el.remove());
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.seoJsonld = "1";
      s.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, noindex, image, canonical, jsonLd, pathname]);
}
